
import { defineComponent } from 'vue';

import { useStore } from 'vuex';

import ModalHeader from '@/modules/modals/components/ModalHeader.vue';
import ModalBody from '@/modules/modals/components/ModalBody.vue';
import ModalFooter from '@/modules/modals/components/ModalFooter.vue';
import ModalService from '@/modules/modals/services/modalService';
import FormsService from '@/services/2.6/FormsService';

import WebEnvConfigService from '@/services/TheWebEnvConfigService';
import { Actions, formFieldsStore } from '@/store';
import IFieldRuleData from '@/models/FieldRuleData';

export default defineComponent({
    components: { ModalHeader, ModalBody, ModalFooter },
    props: ['fieldFriendlyName', 'fieldId', 'originalValue', 'newValue'],
    data() {
        return {
            modal: null,
            rules: [],
        };
    },
    setup() {
        const store = useStore();
        return {
            store,
        };
    },
    mounted() {
        const modalElement = this.$refs.suggestFormattingRule;
        this.modal = ModalService.initialize(modalElement, this);
        ModalService.size(modalElement, '');
        ModalService.open(this.modal);
    },
    methods: {
        async saveAndViewFormattingRules() {
            await this.processRule();
            await this.processSuggestionSuppression();

            ModalService.hide(this.modal);
            (this as any).eventBus.emit('launchDataPreferenceSettingsModal', {
                defaultTabIdx: 1,
                fieldId: this.fieldId,
            });
        },
        async save() {
            await this.processRule();
            await this.processSuggestionSuppression();
            ModalService.hide(this.modal);
        },
        async skip() {
            await this.processSuggestionSuppression();
            ModalService.hide(this.modal);
        },
        async processRule() {
            const webEnvConfig = await WebEnvConfigService.getInstance().getConfigByHost();
            let rules: IFieldRuleData[] = [];
            rules = await new FormsService(webEnvConfig).getDataFieldRules(this.fieldId);
            rules.push(this.createRule(rules));
            await this.saveRule(rules);
        },
        createRule(rules: IFieldRuleData[]) {
            return {
                priorityOrder: rules.length,
                ruleId: 0,
                textEditOption: 2,
                textEditValue: this.newValue,
                textMatchCriteria: this.originalValue,
                textMatchOption: 1,
            };
        },
        async processSuggestionSuppression() {
            const suggestionSuppression = document.getElementById('suggestionSuppression') as HTMLInputElement;
            const status = suggestionSuppression.checked ? false : true;
            await this.saveSuggestionSuppression(status);
        },
        async saveRule(rules: IFieldRuleData[]) {
            await formFieldsStore.saveFieldRules({
                fieldId: this.fieldId,
                fieldRules: rules,
            });
        },
        async saveSuggestionSuppression(status: boolean) {
            await formFieldsStore.saveSuggestFormattingRule({
                fieldId: this.fieldId,
                suggestFormattingRule: status,
            });
        },
    },
});
